module.exports = __webpack_public_path__ + "img/kreditpro.68a013b6.png";